import {
  AtividadeColetiva,
  FatoVisitaDomiciliar,
  OrigemDadoEnum,
  TipoRegistroHistoricoClinico,
} from 'graphql/types.generated'
import { turnoByStringRecord, turnoRecord } from 'types/enums'
import { formatDate, formatDateAndHoursMinutes, toDate } from 'util/date/formatDate'
import { tipoAtividadeToIdRecord } from 'view/atividade-coletiva/model-atividadeColetiva'

import {
  AcompanhamentoUltimosContatosModel,
  convertTag,
} from '../folha-rosto/components/ultimos-contatos/converter-ultimosContatos'
import { FolhaRostoUltimosContatosModel } from '../folha-rosto/components/ultimos-contatos/model'
import { tipoRegistroHistoricoData } from '../historico/model/model-historico'

export const getTipoRegistroAcompanhamentoUltimosContatos = (contato: AcompanhamentoUltimosContatosModel) => {
  return contato.hasMarcadorConsumoAlimentar
    ? TipoRegistroHistoricoClinico.CONSUMO_ALIMENTAR
    : contato.tipoApresentacao ?? contato.tipoAtendProf
}

export const convertAtividadeColetivaToContatosModel = (
  atividadeColetiva: AtividadeColetiva
): FolhaRostoUltimosContatosModel => {
  const historicoDataRecord = tipoRegistroHistoricoData[TipoRegistroHistoricoClinico.ATIVIDADE_COLETIVA]
  const cidadao = atividadeColetiva.participante
    ? atividadeColetiva.participante.cidadao
    : atividadeColetiva.observacao!.cidadao
  return {
    id: atividadeColetiva.id,
    tipo: TipoRegistroHistoricoClinico.ATIVIDADE_COLETIVA,
    title: historicoDataRecord.descricao,
    barColor: historicoDataRecord.barColor,
    icon: historicoDataRecord.icon,
    color: historicoDataRecord.iconColor,
    dataOrTurno: `${formatDate(atividadeColetiva.dataAtividade)} - ${turnoRecord[atividadeColetiva.turno]}`,
    headerTags: convertTag(historicoDataRecord.tags, atividadeColetiva.id),
    historicoAtendimento: {
      idAtividadeColetiva: atividadeColetiva.id,
      codigoUnicoRegistro: atividadeColetiva.uuid,
      idCidadao: cidadao!.id,
      cpfCnsCidadao: cidadao!.cpf ?? cidadao!.cns,
      isAtendRecente: false,
      dataAtendimento: toDate(atividadeColetiva.dataAtividade).getTime(),
      tipoApresentacao: TipoRegistroHistoricoClinico.ATIVIDADE_COLETIVA,
      origemAtendimento: OrigemDadoEnum.PEC,
      coSubtipoAtendimento: tipoAtividadeToIdRecord[atividadeColetiva.tipoAtividade],
    },
    hasObservacao: false,
    isCuidadoCompartilhado: false,
  }
}

export const convertFatoVisitaDomiciliarToContatosModel = (
  visitaDomiciliar: FatoVisitaDomiciliar
): FolhaRostoUltimosContatosModel => {
  const historicoDataRecord = tipoRegistroHistoricoData[TipoRegistroHistoricoClinico.VISITA_DOMICILIAR]
  const turno = turnoByStringRecord[visitaDomiciliar.turno.descricao.toLowerCase()]
  return {
    id: visitaDomiciliar.nuUuidFicha,
    tipo: TipoRegistroHistoricoClinico.VISITA_DOMICILIAR,
    title: historicoDataRecord.descricao,
    barColor: historicoDataRecord.barColor,
    icon: historicoDataRecord.icon,
    color: historicoDataRecord.iconColor,
    dataOrTurno: `${formatDate(visitaDomiciliar.dataVisita)} - ${turnoRecord[turno]}`,
    headerTags: convertTag(historicoDataRecord.tags, visitaDomiciliar.dimensaoDesfechoVisita.id),
    historicoAtendimento: {
      isAtendRecente: false,
      codigoUnicoRegistro: visitaDomiciliar.nuUuidFicha,
      dataAtendimento: toDate(visitaDomiciliar.dataVisita).getTime(),
      tipoApresentacao: TipoRegistroHistoricoClinico.VISITA_DOMICILIAR,
      cpfCnsCidadao: visitaDomiciliar.cpfCidadao ?? visitaDomiciliar.cnsCidadao,
      origemAtendimento: visitaDomiciliar.origem,
    },
    hasObservacao: false,
    isCuidadoCompartilhado: false,
  }
}

export const convertAcompanhamentoUltimosContatosToContatosModel = (
  contato: AcompanhamentoUltimosContatosModel
): FolhaRostoUltimosContatosModel => {
  const tipoAtendimentoEnum = getTipoRegistroAcompanhamentoUltimosContatos(contato)
  const historicoDataRecord = tipoRegistroHistoricoData[tipoAtendimentoEnum.toString()]
  const isCuidadoCompartilhado = tipoAtendimentoEnum == TipoRegistroHistoricoClinico.CUIDADO_COMPARTILHADO
  return {
    id: contato.codigoUnicoRegistro,
    tipo: contato.tipoApresentacao,
    title: historicoDataRecord.descricao,
    barColor: historicoDataRecord.barColor,
    icon: historicoDataRecord.icon,
    color: historicoDataRecord.iconColor,
    dataOrTurno: formatDateAndHoursMinutes(contato.dataAtendimento),
    historicoAtendimento: contato,
    hasObservacao: contato.hasObservacao,
    isCuidadoCompartilhado: isCuidadoCompartilhado,
  }
}
